import i18next from "i18next";
import { ColumnProps } from "@wit/mpesa-ui-components/lib/components/table/table.component";
import moment from "moment";
import { MIN_ELAPSED_MINUTES_TO_RE_TRIGGER_JOB } from "./jobs-list.constants";
import { IJobAvailability } from "./jobs-list.interface";

export const JobsListUtils = {
  getJobsColumns: (): ColumnProps[] => {
    return [
      {
        formKey: "name",
        ratio: 12 / 12,
        isEditable: false,
        label: i18next.t("pages.tools.jobsList.triggerJob.table.headers.jobName"),
      },
    ];
  },

  checkJobAvailability: (jobName: string): IJobAvailability => {
    const lastTriggeredAtDateTime = sessionStorage.getItem(jobName);
    if (lastTriggeredAtDateTime) {
      const elapsedTimeInSeconds = moment().diff(lastTriggeredAtDateTime, "second");

      return {
        canBeTriggered: elapsedTimeInSeconds > MIN_ELAPSED_MINUTES_TO_RE_TRIGGER_JOB * 60,
        remainingTimeInSeconds: elapsedTimeInSeconds,
      };
    } else {
      sessionStorage.removeItem(jobName);

      return {
        canBeTriggered: true,
        remainingTimeInSeconds: 0,
      };
    }
  },
};
